import React, { useState, useEffect } from 'react'
import { useTranslate, useNotify, useRefresh } from 'react-admin'
import {
  Tab as TabMUI,
  Box,
  Typography,
  Divider,
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  CircularProgress,
} from '@mui/material'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import { styled } from '@mui/material/styles'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AvTimerIcon from '@mui/icons-material/AvTimer'
import EventIcon from '@mui/icons-material/Event'
import { LinearScale, VerticalScale } from 'src/components/uiElements/iconCSS/IconCSS'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { turquoise, lightcyan, blue } from 'src/assets/colors'
import { useImage } from 'src/components/customHooks/useImage'
import { TrainSegmentTicket } from 'src/components/pages/sales/reservation/logic/train/TrainSegmentTicket'
import TrainIcon from '@mui/icons-material/Train'
import { getDay, getDayWithTimeZone } from 'src/components/pages/sales/reservation/helper/getDay'
import { LoadingButton } from '@mui/lab'
import { itemServices } from 'src/services/reservation/item/item.service'
import { TrainSegmentCondition } from 'src/components/pages/sales/reservation/logic/train/TrainSegmentCondition'
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import {
  CANCELLED,
  INVOICED,
  PENDING,
  PARTIAL_REFUND,
  REFUND_IN_PROGRESS,
  DELETED,
  EXPIRED,
  REFUNDED,
  CONFIRMED,
} from 'src/components/pages/sales/reservation/logic/common/state'
import { businessRuleServices } from 'src/services/sales/businessRule/businessRule.service'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import {
  PERMISSION_REFOUND,
} from 'src/helper/Permission'


const Accordion = styled((props) => <MuiAccordion {...props} />)(() => ({
  '&:before': {
    display: 'none',
  },
}))

export const GetLogoImageAirline = ({ fileName, style }) => {
  const extensions = ['png', 'jpg', 'jpeg', 'gif']
  const { loading, error, image } = useImage({ fileName, extensions })
  if (error) return undefined
  return <>{loading ? <Typography>loading</Typography> : <img style={style} src={image} alt={fileName} />}</>
}

const MarketingCarrier = ({ marketing_carrier }) => {
  const translate = useTranslate()
  const [loadingMarketingCarrier, setLoadingMarketingCarrier] = useState(false)
  const [marketingCarrier, setMarketingCarrier] = useState(false)

  useEffect(() => {
    getMarketingCarrier(marketing_carrier)
  }, [marketing_carrier])

  const getMarketingCarrier = async (marketing_carrier) => {
    try {
      setLoadingMarketingCarrier(true)
      const params = {
        short_name__ilike: marketing_carrier,
      }
      const response = await businessRuleServices.getMarketingCarrierTrain(params)
      if (response && response.length) {
        setMarketingCarrier(response[0]?.long_name)
      } else {
        setMarketingCarrier(marketing_carrier)
      }
    } catch (error) {
      setMarketingCarrier(marketing_carrier)
    } finally {
      setLoadingMarketingCarrier(false)
    }
  }

  return (
    <>
      {loadingMarketingCarrier ? (
        <CircularProgress size={'10px'} />
      ) : (
        <ShowElement data={marketingCarrier} label={translate('ra.field.marketingCarrier')} />
      )}
    </>
  )
}

export const TrainScale = ({ train, hideIssuance }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [selectedSegment, setSelectedSegment] = useState()
  const { segments, hash_, status } = train
  const [loadingStates, setLoadingStates] = useState({})
  const [openModalCondition, setOpenModalCondition] = useState(false)
  const [confirmCancel, setConfirmCancel] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [openConfirmIssuance, setOpenConfirmIssuance] = useState(false)
  const [openConfirmDeleteSegement, setOpenConfirmDeleteSegement] = useState(false)

  const [nameReserveCancel, setNameReserveCancel] = useState('')
  const [nameReserveDelete, setNameReserveDelete] = useState('')
  const [idSegmentReserve, setIdSegmentReserve] = useState(null)
  const [costCancel, setCost] = useState(0)
  const [currencyCostCancel, setCurrencyCost] = useState('')
  const [costCancelLoading, setCostLoading] = useState(false)
  const [errorToCancelSegment, setErrorToCancelSegment] = useState(false)
  const [errorToCancelSegmentMessage, setErrorToCancelSegmentMessage] = useState('') 


  useEffect(() => {
    if (confirmCancel) {
      cancelSegment(
        idSegmentReserve,
        hash_,
        nameReserveCancel,
        setNameReserveCancel,
        setIdSegmentReserve,
        setConfirmCancel,
        setOpenConfirmIssuance
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmCancel])

  useEffect(() => {
    if (confirmDelete) {
      deleteSegment(
        idSegmentReserve,
        hash_,
        nameReserveDelete,
        setNameReserveDelete,
        setIdSegmentReserve,
        setConfirmDelete,
        setOpenConfirmDeleteSegement
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [confirmDelete])

  const getTrainSegments = (list) => {
    if (list && list?.length !== 0) {
      let listTrainSegments = list.map((data) => `${data.origin_name}/${data.arrival_name} - `)
      let concant = listTrainSegments.join('')
      let delete_last_characters = concant.slice(0, -2)
      return delete_last_characters
    }
  }

  const howManyScales = (amount_scale) => {
    if (amount_scale === 0)
      return (
        <>
          <Typography
            component='div'
            style={{
              color: turquoise,
              fontWeight: 600,
              marginBottom: '5px',
            }}
          >
            {translate('ra.title.direct')}
          </Typography>
          <LinearScale />
        </>
      )
    if (amount_scale !== 0)
      return (
        <>
          <Typography
            component='div'
            style={{
              color: turquoise,
              fontWeight: 600,
              marginBottom: '5px',
            }}
          >
            {amount_scale} {translate('ra.title.scale')}
          </Typography>
          <LinearScale direct classToUse={amount_scale} />
        </>
      )
  }

  const cancelSegment = async (
    id,
    hash,
    nameSegment,
    setNameReserveCancel,
    setIdSegmentReserve,
    setConfirmCancel,
    setOpenConfirmIssuance
  ) => {
    try {
      setOpenConfirmIssuance && setOpenConfirmIssuance(false)
      setLoadingStates((prev) => ({
        ...prev,
        [id]: true,
      }))
      const response = await itemServices.cancel_segment_from_item(hash, id)
      if (response) {
        notify('ra.notification.issuance_segment_item_reserve_success', {
          type: 'success',
          messageArgs: { segment: nameSegment },
        })
        return
      }
      notify('ra.notification.issuance_segment_item_reserve_error', {
        type: 'error',
        messageArgs: { segment: nameSegment },
      })
    } catch (error) {
      notify('ra.notification.issuance_segment_item_reserve_error', {
        type: 'error',
        messageArgs: { segment: nameSegment },
      })
    } finally {
      setConfirmCancel && setConfirmCancel(false)
      setNameReserveCancel('')
      setIdSegmentReserve(null)
      customAwait([refresh])
      setLoadingStates((prev) => ({
        ...prev,
        [id]: false,
      }))
    }
  }

  const getCancelCostFromSegment = async (hash, id_Segment) => {
    try {
      setCostLoading(true)
      const constToCancel = await itemServices.get_cost_to_refund_train_segment(hash, id_Segment)
      if (constToCancel?.refund_value && constToCancel?.currency) {
        setCost(constToCancel.refund_value)
        setCurrencyCost(constToCancel.currency)
      }
    } catch (error) {
      const error_messages = error?.response?.data?.detail || 'ra.auth.unknown'
      setErrorToCancelSegmentMessage(error_messages)
      setErrorToCancelSegment(true)
    } finally {
      setCostLoading(false)
    }
  }

  const deleteSegment = async (
    id,
    hash,
    nameSegment,
    setNameReserveDelete,
    setIdSegmentReserve,
    setConfirmDelete,
    setOpenConfirmDeleteSegement
  ) => {
    try {
      setOpenConfirmDeleteSegement && setOpenConfirmDeleteSegement(false)
      setLoadingStates((prev) => ({
        ...prev,
        [id]: true,
      }))
      const response = await itemServices.delete_segment_from_item(hash, id)
      if (response) {
        notify('ra.notification.delete_segment_item_reserve_success', {
          type: 'success',
          messageArgs: { segment: nameSegment },
        })
        return
      }
      notify('ra.notification.delete_segment_item_reserve_error', {
        type: 'error',
        messageArgs: { segment: nameSegment },
      })
    } catch (error) {
      notify('ra.notification.delete_segment_item_reserve_error', {
        type: 'error',
        messageArgs: { segment: nameSegment },
      })
    } finally {
      setConfirmDelete && setConfirmDelete(false)
      setNameReserveDelete('')
      setIdSegmentReserve(null)
      customAwait([refresh])
      setLoadingStates((prev) => ({
        ...prev,
        [id]: false,
      }))
    }
  }

  const segmentName = (train_segment) => {
    if (train_segment && train_segment?.arrival_name && train_segment?.origin_name) {
      return `${train_segment?.origin_name}/${train_segment?.arrival_name}`
    }
    return null
  }

  return (
    <Box style={{ width: '100%', height: 'auto', margin: '15px 0 15px 0' }}>
      <Typography variant='h6' component='span' color={blue} padding={'0px 5px 0px 5px'}>
        {translate('ra.title.segments')} ({segments?.length})
      </Typography>

      <TabContext value={'1'}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList aria-label='lab API tabs example'>
            <TabMUI label={getTrainSegments(segments)} value='1' style={{ maxWidth: 'none' }} />
          </TabList>
        </Box>

        <TabPanel value='1'>
          {segments?.map((trainInformation, index) => {
            return (
              <Box key={index}>
                <Accordion
                  style={{
                    boxShadow: 'none',
                    backgroundColor: lightcyan,
                    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
                    borderRadius: '10px',
                    margin: '10px 0 10px 0',
                  }}
                  // expanded={true}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls='panel1a-content'
                    id='panel1a-header'
                  >
                    <Box className='accordion_summary_container'>
                      <Box display={'flex'}>
                        <Box className='accordion_summary_column' position={'relative'} style={{ flex: 1 }}>
                          <Typography
                            variant='h7'
                            component='div'
                            fontWeight={600}
                            display={'flex'}
                            justifyContent={'center'}
                            flexDirection={'column'}
                            alignItems={'center'}
                          >
                            {translate('ra.title.segment')} {index + 1}
                            <TrainIcon style={{ color: turquoise }} />
                          </Typography>
                        </Box>
                        <Box className='accordion_summary_column'>
                          <Typography component='div'>{translate('ra.title.departure')}</Typography>
                          <Typography variant='h7' component='div' fontWeight={600}>
                            {trainInformation?.origin_name}
                          </Typography>

                          <Typography
                            component='div'
                            style={{
                              color: blue,
                            }}
                          >
                            {getDay(trainInformation?.origin_datetime, true)}
                          </Typography>
                        </Box>
                        <Box className='accordion_summary_column'>
                          {howManyScales(trainInformation?.schedule?.length - 1)}
                        </Box>
                        <Box className='accordion_summary_column'>
                          <Typography component='div'>{translate('ra.title.arrival')}</Typography>
                          <Typography component='div' fontWeight={600}>
                            {trainInformation?.arrival_name}
                          </Typography>

                          <Typography
                            variant='h7'
                            component='div'
                            style={{
                              color: blue,
                            }}
                          >
                            {getDay(trainInformation?.arrival_datetime, true)}
                          </Typography>
                        </Box>
                        {trainInformation?.expiration_datetime && (
                          <Box className='accordion_summary_column'>
                            <Typography component='div' fontWeight={600}>
                              {translate('ra.field.expiration')}
                            </Typography>
                            <Typography component='div' className='accordion_summary_column_red'>
                              <EventIcon />
                              {getDayWithTimeZone(
                                trainInformation?.expiration_datetime,
                                true,
                                false,
                                process.env.REACT_APP_TIME_ZONE
                              )}
                            </Typography>
                          </Box>
                        )}

                        <Box className='accordion_summary_column'>
                          <Typography component='div' fontWeight={600}>
                            {translate('ra.field.segment_price')}
                          </Typography>
                          <Typography component='div' className='accordion_summary_column_red'>
                            ${' '}
                            {parseFloat(
                              (trainInformation?.price?.business?.values?.tarifa_comisionable).toFixed(2)
                            )}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails>
                    {trainInformation?.schedule?.length >= 1
                      ? trainInformation?.schedule?.map((program, index) => {
                          return (
                            <Box margin={'10px 0 10px 0'} key={index}>
                              {index !== 0 ? (
                                <Box className='accordion_details_scale'>
                                  <Typography component='div' className='number_scale'>
                                    {translate('ra.title.scale')} {index}
                                  </Typography>
                                </Box>
                              ) : undefined}
                              <Box className='accordion_details_scale_container_train'>
                                <Box className='accordion_details_scale_container_train_details'>
                                  <Box className='vertical_scale'>
                                    <VerticalScale style={{ height: '95px' }} />
                                  </Box>
                                  <Box className='column_details'>
                                    <Box className='left'>
                                      <Typography
                                        style={{ display: 'flex', flex: 1, justifyContent: 'center' }}
                                        component='div'
                                        color={blue}
                                        fontWeight={600}
                                      >
                                        {program.origin?.label}
                                      </Typography>
                                      <Typography
                                        style={{ display: 'flex', flex: 1, justifyContent: 'center' }}
                                        component='div'
                                        color={turquoise}
                                        fontWeight={600}
                                      >
                                        {getDay(program.departure, true)}
                                      </Typography>
                                    </Box>
                                    <Box className='center'>
                                      <Typography
                                        component='div'
                                        color={turquoise}
                                        fontWeight={600}
                                        display={'flex'}
                                        alignItems={'center'}
                                      >
                                        <AvTimerIcon /> {translate('ra.title.total_duration')}:{' '}
                                        {program.duration}
                                      </Typography>
                                    </Box>
                                    <Box className='left'>
                                      <Typography
                                        component='div'
                                        style={{ display: 'flex', flex: 1, justifyContent: 'center' }}
                                        color={blue}
                                        fontWeight={600}
                                      >
                                        {program.destination?.label}
                                      </Typography>
                                      <Typography
                                        component='div'
                                        style={{ display: 'flex', flex: 1, justifyContent: 'center' }}
                                        color={turquoise}
                                        fontWeight={600}
                                      >
                                        {getDay(program.arrival, true)}
                                      </Typography>
                                    </Box>
                                  </Box>
                                  <Box className='column_details small'>
                                    <Box className='rigth'>
                                      <ShowElement
                                        data={program.operatingCarrier}
                                        label={translate('ra.field.operatingCarrier')}
                                      />
                                      <MarketingCarrier marketing_carrier={program.operatingCarrier} />
                                    </Box>
                                  </Box>
                                </Box>
                                {program?.seatReservationConditions && (
                                  <Box
                                    display={'flex'}
                                    justifyContent={'flex-start'}
                                    width={'90%'}
                                    marginY={'10px'}
                                  >
                                    <ShowElement
                                      data={program?.seatReservationConditions}
                                      label={translate('ra.field.seat')}
                                    />
                                  </Box>
                                )}
                              </Box>
                            </Box>
                          )
                        })
                      : undefined}
                  </AccordionDetails>
                </Accordion>
                <Box padding={'0 15px 0 15px'}>
                  <div style={{display:'flex', flexDirection:'row', flexWrap:'wrap',justifyContent:'space-between'}}>
                    <ShowElement
                      data={
                        trainInformation?.status_detail === CONFIRMED
                          ? INVOICED
                          : trainInformation?.status_detail
                      }
                      label={translate('ra.field.status')}
                      status
                    />
                    {trainInformation?.refund_data ? <HasPermission resource='item' permission={PERMISSION_REFOUND}>
                      <ShowElement
                        data={trainInformation?.refund_data?.amount?.currency + ' ' +
                          trainInformation?.refund_data?.amount?.value}
                        label={translate('ra.field.amount_refunded')}
                      />
                    </HasPermission>:''}
                  </div>
                </Box>
                <Box display={'flex'} margin={'20px 0 30px 0'}>
                  <Box flex={3}>
                    {trainInformation?.status_detail !== REFUNDED &&
                      trainInformation?.status_detail !== DELETED &&
                      trainInformation?.status_detail !== EXPIRED && (
                        <TrainSegmentTicket
                          ticket_url={trainInformation?.url_ticket}
                          ticketing_options={trainInformation?.ticketing_options}
                          status={status}
                          status_segment={trainInformation?.status_detail}
                          pnr={trainInformation?.pnr}
                        />
                      )}
                  </Box>
                  <Box flex={2} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                    {trainInformation?.pnr &&
                      trainInformation?.url_ticket &&
                      Array.isArray(trainInformation?.url_ticket) &&
                      trainInformation?.url_ticket.length > 0 &&
                      !trainInformation?.url_ticket.every((record) => 'url' in record) &&
                      status !== CANCELLED && (
                        <ShowElement data={trainInformation?.pnr} label={translate('ra.field.pnr')} />
                      )}
                  </Box>
                  <HasPermission resource='item' permission={PERMISSION_REFOUND}>
                  {!hideIssuance && (
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} flex={1}>
                      <ConfirmationDialog
                        title={
                          errorToCancelSegment
                            ? translate(errorToCancelSegmentMessage)
                            : translate('ra.message.cancel_item_segment', {
                                segment: nameReserveCancel,
                                currency: currencyCostCancel,
                                cost: costCancel,
                              })
                        }
                        buttonConfirmText={errorToCancelSegment ? null : translate('ra.action.to_confirm')}
                        buttonCancel={
                          errorToCancelSegment ? translate('ra.action.back') : translate('ra.action.cancel')
                        }
                        setOpen={setOpenConfirmIssuance}
                        setConfirm={setConfirmCancel}
                        open={openConfirmIssuance}
                        loadingMessage={costCancelLoading}
                      />
                      {(status === INVOICED ||
                        status === PARTIAL_REFUND ||
                        status === REFUND_IN_PROGRESS) && (
                        <LoadingButton
                          color='error'
                          variant='contained'
                          size='medium'
                          style={{ margin: '5px 5px 5px 0' }}
                          disabled={trainInformation?.status_detail !== INVOICED}
                          onClick={() => {
                            setOpenConfirmIssuance(true)
                            setNameReserveCancel(segmentName(trainInformation))
                            setIdSegmentReserve(trainInformation?.id)
                            getCancelCostFromSegment(hash_, trainInformation?.id)
                          }}
                          loading={loadingStates[trainInformation?.id]}
                        >
                          {translate('ra.action.issuance')}
                        </LoadingButton>
                      )}

                      <ConfirmationDialog
                        title={translate('ra.message.delete_item_segment', {
                          segment: nameReserveDelete,
                        })}
                        buttonConfirmText={translate('ra.action.to_confirm')}
                        buttonCancel={translate('ra.action.cancel')}
                        setOpen={setOpenConfirmDeleteSegement}
                        setConfirm={setConfirmDelete}
                        open={openConfirmDeleteSegement}
                      />
                      {status === PENDING && segments?.length > 1 && (
                        <LoadingButton
                          color='error'
                          variant='contained'
                          size='medium'
                          style={{ margin: '5px 5px 5px 0' }}
                          disabled={trainInformation?.status_detail === 'DELETED'}
                          onClick={() => {
                            setOpenConfirmDeleteSegement(true)
                            setNameReserveDelete(segmentName(trainInformation))
                            setIdSegmentReserve(trainInformation?.id)
                          }}
                          loading={loadingStates[trainInformation?.id]}
                        >
                          {translate('ra.title.delete_segment')}
                        </LoadingButton>
                      )}
                    </Box>
                  )}
                  </HasPermission>
                </Box>

                <Button
                  onClick={() => {
                    setOpenModalCondition(true)
                    setSelectedSegment(trainInformation)
                  }}
                  style={{ fontWeight: 600, textDecoration: 'underline' }}
                >
                  {translate('ra.action.see_conditions')}
                </Button>
              </Box>
            )
          })}
        </TabPanel>
      </TabContext>
      <Divider />

      <TrainSegmentCondition
        open={openModalCondition}
        handleClose={() => {
          setOpenModalCondition(false)
          setSelectedSegment(null)
        }}
        trainInformation={selectedSegment}
      />
    </Box>
  )
}
